import Header from '../Header';
import React from 'react';

import DataProvider from '../DataProvider';
import UserProvider from '../UserProvider';

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Inter', sans-serif;
  }
`;

function App() {
  return (
    <UserProvider>
      <DataProvider>
        <GlobalStyle />
        <div className='wrapper'>
          <Header />
        </div>
      </DataProvider>
    </UserProvider>
  );
}

export default App;
